export const environment = {
  komainuHost: 'https://beta.data.npolar.no/-/auth',
  kinkoHost: 'https://beta.data.npolar.no/-/api',
  mapArchiveDatasetId: '6776c26c-c7c5-4dae-a450-e2e89e9e8fa9',
  vesselDatasetId: '445d6325-dd81-4dae-ac50-eafe76d6af39',
  geologicalSampleDatasetId: 'cca34136-2110-5b1a-9fda-f1bea3c024e2',
  planktonDatasetId: '6089fde0-5c77-449a-aba0-1517c022bca6',
  kphLiveDatasetId: '01f5ef26-d45b-486e-809a-49edd1d38312',
};
